function createArohaPackaging(config, io = {}) {
  const parents = new Set(config.parentVariantIds.map(String));
  const supported = config.currency === 'NZD' && Object.values(config.upgrades).every(item => item.available && item.price === item.expectedPrice && item.tracked === false);
  const themeAllowed = Number(config.stagingThemeId) === 0 || Number(config.stagingThemeId) === Number(config.themeId);
  const ready = config.enabled === true && supported && themeAllowed;
  const send = io.fetch || fetch;
  const fail = () => new Error(config.messages.review);
  const variant = item => String(item.variant_id ?? item.id);
  const quantity = value => {
    const result = Number(value);
    if (!Number.isSafeInteger(result) || result < 0) throw fail();
    return result;
  };
  function buildAddPayload(formData, choice) {
    if (!ready || choice === 'standard') return null;
    const parentId = String(formData.get('id'));
    const upgrade = config.upgrades[choice];
    const amount = quantity(formData.get('quantity') || 1);
    if (!parents.has(parentId) || !upgrade || amount === 0 || formData.get('selling_plan')) throw fail();
    const properties = {};
    for (const [name, value] of formData.entries()) {
      const match = /^properties\[([^\]]+)\]$/.exec(name);
      if (match) properties[match[1]] = value;
    }
    const payload = { items: [
      { id: Number(parentId), quantity: amount, properties },
      { id: Number(upgrade.variantId), quantity: amount, properties: { 'Packaging rule': "Each packaging item receiving the NZ$15 MDF-set discount replaces one included open MDF box. Full-price packaging is additional." } }
    ] };
    for (const name of ['sections', 'sections_url']) if (formData.has(name)) payload[name] = formData.get(name);
    return payload;
  }
  function fetchAdd(form, formData, originalConfig, url) {
    const field = form.querySelector('[data-aroha-packaging-choice]');
    if (!field || !ready) return send(url, originalConfig);
    const payload = buildAddPayload(formData, field.value);
    if (!payload) return send(url, originalConfig);
    return send(url, { ...originalConfig, headers: { ...originalConfig.headers, 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
  }
  function normalizeAddResponse(response, parentId) {
    if (!ready || response.status || !Array.isArray(response.items)) return response;
    const parent = response.items.find(item => variant(item) === String(parentId));
    return parent ? { ...response, ...parent } : response;
  }
  return { ready, config, buildAddPayload, fetchAdd, normalizeAddResponse };
}
if (typeof module === 'object' && module.exports) module.exports = createArohaPackaging;
if (typeof document !== 'undefined') {
  const source = document.getElementById('ArohaPackagingConfig');
  if (source) {
    const api = createArohaPackaging(JSON.parse(source.textContent));
    window.ArohaPackaging = api;
    if (api.ready) {
      const choices = new Map();
      const decorate = () => {
        document.querySelectorAll('[data-aroha-packaging-picker]').forEach(fieldset => {
          fieldset.hidden = false;
          fieldset.disabled = false;
          const select = fieldset.querySelector('select');
          if (!fieldset.dataset.ready) {
            select.value = choices.get(fieldset.dataset.productId) || 'standard';
            fieldset.dataset.ready = 'true';
          }
        });
      };
      document.addEventListener('change', event => {
        if (event.target.matches('[data-aroha-packaging-choice]')) choices.set(event.target.closest('fieldset').dataset.productId, event.target.value);
      });
      let scheduled = false;
      new MutationObserver(() => {
        if (!scheduled) {
          scheduled = true;
          queueMicrotask(() => { scheduled = false; decorate(); });
        }
      }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      decorate();
    }
  }
}
